export default __webpack_public_path__ + "static/media/fitness-next-icon.09b6ca59.svg";